<template>
  <div class="container-bg-gray">
    <div class="container pt-5" data-aos="fade-up">
      <p class="text-center font-noto-b mb-0">{{ $t('services.services-information')}}</p>
    </div>
    <div class="pig" data-aos="fade-left">
      <img loading="lazy" src="@/assets/icons/pig.svg" :alt="$t('alt.services.pig-img')">
    </div>
  </div>
</template>

<style scoped>
  .container-bg-gray p {
    font-size: 1.6em;
  }

  .pig {
    text-align: end;
  }

  .pig img {
    width: 100px;
  }
</style>
